// extracted by mini-css-extract-plugin
export var logo = "_98-2";
export var logoWrapper = "_98-1";
export var strip = "_98-0";